import { CanDeactivate } from '@angular/router';
import { MemberformComponent } from '@app/components/members/memberform/memberform.component';
import { Injectable } from "@angular/core";

// tslint:disable-next-line:max-line-length
@Injectable()
export class CreateMemberCanDeactivateGuardService implements CanDeactivate<MemberformComponent> {

canDeactivate(component: MemberformComponent): boolean {
  if (component.memberform.dirty && component.action !== 'new') {
    return confirm('Är du säker på att du vill lämna utan att spara ändringarna ?');
  }
  return true;
}
}
